/**
 * @file Cookies.tsx
 * @module Cookies
 * @description Axios atbildes interceptors, kas izgūst un saglabā autentifikācijas
 *              tokenus no atbildes galvenēm. Saglabā accessToken un refreshToken
 *              sesijas krātuvē (sessionStorage) turpmākiem API pieprasījumiem.
 */

import axios from "axios";
import { useEffect } from "react";

/**
 * Reads a cookie value by name from document.cookie.
 * @param name - Cookie name to look up
 * @returns The decoded cookie value, or null if not found
 */
export function getCookie(name: string) {
	if (!document.cookie) {
		return null;
	}

	const xsrfCookies = document.cookie
		.split(";")
		.map((c) => c.trim())
		.filter((c) => c.startsWith(name + "="));

	if (xsrfCookies.length === 0) {
		return null;
	}
	return decodeURIComponent(xsrfCookies[0].split("=")[1]);
}

/**
 * Headless component that registers the CSRF token Axios interceptor on mount.
 * Reads the "csrftoken" cookie and adds it as "x-csrftoken" header to all requests.
 */
export const Cookies = () => {
	useEffect(() => {
		axios.interceptors.request.use(
			(config) => {
				const cookie = getCookie("csrftoken");
				if (cookie) config.headers["x-csrftoken"] = cookie;
				return config;
			},
			(error) => {
				Promise.reject(error);
			}
		);
	}, []);

	return <></>;
};
